const ItemsAboutUs = ({children, icon=null, className=null}) => {
    return (
        <div className={`itemsAboutUs ${className}`}>
            <div className="iconAboutUs">
                {icon}
            </div>
            
            <div className="textAboutUs ">
                {children}
            </div>

        </div>

    )
}

export default ItemsAboutUs;